import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LightgalleryProvider } from 'react-lightgallery';

import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import { CardsContainer, RoundCircle } from '../../styledComponents/Activity';
import { CommonText, Container } from '../../styledComponents/common';
import {
  ActivityTextSection,
  FlexSection,
} from '../../styledComponents/members';
import SingleCard from './SingleCard';

const CardsList = props => {
  const { isLoading, evidenceList, count } = props;
  const { t } = useTranslation();
  const [timeRange, setTimeRange] = useState([]);
  const [counterState, setCounterState] = useState(0)

  // useEffect(() => {
  //   if (!evidenceList || count === 0) {
  //     return setTimeRange([]);
  //   }

  //   const timeList = timeRangeList.map(timeRange => ({
  //     ...timeRange,
  //     evidenceImages: [], // Reset evidenceImages to avoid mutation
  //   }));

  //   const timeRangeMap = Object.fromEntries(
  //     timeList.map(timeRange => [
  //       parseInt(timeRange.startTimeRange),
  //       timeRange,
  //     ]),
  //   );

  //   evidenceList.forEach(image => {
  //     const takenHour = moment(image.created_at).local().hour();
  //     const localTime = moment(image.created_at).local().format('h:mm A');
  //     image.localTime = localTime;

  //     timeRangeMap[takenHour]?.evidenceImages.push(image);
  //   });

  //   setTimeRange(timeList);
  // }, [evidenceList, count]);
  useEffect(() => {
    setCounterState(prev => prev + 1)
  },[evidenceList]);

  {/* Loading and Zero Data State */}
  if (isLoading) {
    return (
      <Container padding="10px 10px">
        <ComponentCircleLoader />
      </Container>
    )
  }

  return (
    <Container padding="10px 10px">
      {count == 0 && (
        <NoDataComponent
          title={t('no_evidence_image_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
      <LightgalleryProvider
        key={counterState}
        lightgallerySettings={{
          width: '100%',
          height: '100%',
          hideControlOnEnd: true,
          loop: false,
          download: false,
          hideBarsDelay: 1000,
          mousewheel: true,
        }}
      >
        {evidenceList && count > 0 && (
          <CardsContainer key={counterState}>
            {evidenceList.map((item, i) => (
              <SingleCard
                evidenceItem={item}
                key={i}
                imageId={item.id}
                image={item.image}
                timestamp={moment(item.created_at).local().format('h:mm A, Do MMM, YYYY')}
                user={item.created_by}
                officeNumber={item.office_name}
                taskCode={item.task_code}
              />
            ))}
          </CardsContainer>
        )}
      </LightgalleryProvider>
    </Container>
  );
};

export default CardsList;
